var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"content_html",attrs:{"fluid":""}},[_c('b-container',{staticStyle:{"max-width":"1280px"}},[_c('h1',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$props.title)}}),_c('p',{staticClass:"content_html",domProps:{"innerHTML":_vm._s(_vm.$props.html)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }